import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { QualificationEntity } from '../../../../entities/mdqx/doctor/qualification.entity';
import { QualificationActions } from '../../../actions/mdqx/doctor/qualification.actions';

export const QUALIFICATION_FEATURE_KEY = 'qualification';

export interface QualificationState extends EntityState<QualificationEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<QualificationEntity>({
    selectId: (Entity) => Entity.Id,
    sortComparer: (a, b) => a.Name.localeCompare(b.Name),
});

const initialState: QualificationState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const qualificationReducer = createReducer(
    initialState,
    on(QualificationActions.loadSuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(QualificationActions.putSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
        }),
    ),
    on(QualificationActions.changeSuccess, (state, { Payload }) =>
        adapter.setOne(Payload, {
            ...state,
        }),
    ),
    on(QualificationActions.deleteSuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, {
            ...state,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllQualification = selectAll;
export const selectQualificationEntities = selectEntities;

export const selectQualificationFetched = (state: QualificationState) => state.fetched;
// export const selectQualificationLatestUpdatedAt = (state: QualificationState) => state.latestUpdatedAt;
